"use client"

import type { DemoAnalytics } from "@resolto/domain"

export function AnalyticsCharts({ analytics }: { analytics: DemoAnalytics }) {
  const maxRequests = Math.max(...analytics.weekly.map((item) => item.requests))
  return (
    <div className="analytics-charts">
      <figure className="panel weekly-chart">
        <figcaption>
          <h2>Requests and outcomes by week</h2>
          <p>Measured demo records; bars remain available as a data table below.</p>
        </figcaption>
        <div className="bar-chart" aria-hidden="true">
          {analytics.weekly.map((item) => (
            <div key={item.week}>
              <div
                className="bar-stack"
                style={{ height: `${(item.requests / maxRequests) * 180}px` }}
              >
                <span
                  className="bar-resolved"
                  style={{ height: `${(item.resolved / item.requests) * 100}%` }}
                />
                <span
                  className="bar-escalated"
                  style={{ height: `${(item.escalated / item.requests) * 100}%` }}
                />
              </div>
              <span>{item.week}</span>
            </div>
          ))}
        </div>
        <div className="chart-legend">
          <span>
            <i className="legend-resolved" />
            Resolved
          </span>
          <span>
            <i className="legend-escalated" />
            Escalated
          </span>
          <span>
            <i className="legend-active" />
            Still active
          </span>
        </div>
        <table className="sr-only">
          <caption>Requests and outcomes by week</caption>
          <thead>
            <tr>
              <th>Week</th>
              <th>Requests</th>
              <th>Resolved</th>
              <th>Escalated</th>
            </tr>
          </thead>
          <tbody>
            {analytics.weekly.map((item) => (
              <tr key={item.week}>
                <th>{item.week}</th>
                <td>{item.requests}</td>
                <td>{item.resolved}</td>
                <td>{item.escalated}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </figure>
      <section className="panel outcome-breakdown">
        <div>
          <h2>Resolution outcomes</h2>
          <p>Every total links back to underlying records in configured mode.</p>
        </div>
        <dl>
          {analytics.resolutionOutcomes.map((outcome) => (
            <div key={outcome.name}>
              <dt>{outcome.name}</dt>
              <dd>{outcome.value}</dd>
              <span style={{ width: `${(outcome.value / 62) * 100}%` }} aria-hidden="true" />
            </div>
          ))}
        </dl>
      </section>
    </div>
  )
}
